import React, { useCallback, useMemo } from "react";
import { View } from "react-native";
import { useI18nMessage, useI18n } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { ReturnQuestionType } from "../../../../../../../projection/returnQuestion/returnQuestion.constants";
import { DOMAIN, I18nMessages } from "../../../../../i18n/i18n";
import { useReturnQuestionFeedback } from "../../behaviors/useReturnQuestionFeedback";
import { feedbackForReturnQuestion } from "../../util/returnQuestionFeedback";
import { ReturnQuestionItem } from "../ReturnQuestionItem";
import { style as returnQuestionFeedbackItemStyle } from "./ReturnQuestionFeedbackItem.style";

const ReturnQuestionFeedbackItem: ReturnQuestionItem<ReturnQuestionType.HOST_DEFAULT> = ({ returnQuestion }) => {
  const { formatMessage } = useI18n({ domain: DOMAIN });
  const unansweredText = useI18nMessage({ domain: DOMAIN, id: I18nMessages.FEEDBACK_UNANSWERED });

  const returnQuestionFeedback = useReturnQuestionFeedback();

  const translate = useCallback(
    (returnQuestionName: string) => formatMessage({ id: returnQuestionName, defaultMessage: returnQuestionName }),
    [formatMessage],
  );
  const feedback = feedbackForReturnQuestion({ feedback: returnQuestionFeedback, returnQuestion, translate }).join(
    " / ",
  );

  const style = useMemo(() => returnQuestionFeedbackItemStyle(), []);

  return (
    <View style={style.container}>
      {returnQuestion.translationKey && (
        <Text level={2} style={style.title} variant="detailBold">
          {formatMessage({ id: returnQuestion.translationKey })}
        </Text>
      )}
      <Text level={1} variant="detail">
        {feedback || unansweredText}
      </Text>
    </View>
  );
};

export { ReturnQuestionFeedbackItem };
